import { render, staticRenderFns } from "./items-type-sublet.vue?vue&type=template&id=35530416&scoped=true"
import script from "./items-type-sublet.vue?vue&type=script&lang=js"
export * from "./items-type-sublet.vue?vue&type=script&lang=js"
import style0 from "./items-type-sublet.vue?vue&type=style&index=0&id=35530416&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35530416",
  null
  
)

export default component.exports